export default __webpack_public_path__ + "static/media/nr4.b307080b.svg";